import React from 'react';
import styled from 'styled-components';
import { PersonalityTypes } from 'Types/PersonTypes';
import {
  boxShadow,
  maxWidth,
  primaryColor,
  primaryFont, retina, wMBold, wMedium,
} from 'Utils/utilsStyle';
import EngagementProfileWidget from './EngagementProfileWidget';

const Body = styled.div`
  display: flex;
  align-items: center;
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #fff;
  padding: 18px 14px;
  margin-bottom: 10px;
  .body-item {
    min-width: 18%;
    width: 18%;
    font-size: 20px;
    font-weight: ${wMBold};
    font-family: ${primaryFont};
    color: #424B50;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     font-size: 16px;
    }
    &:nth-child(1) {
    min-width: 28%;
    width: 28%;
    }
    &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(5) {
     text-align: center;
    }
    &.body-profile {

    }
    &.body-accounts {
      font-size: 16px;
      color: ${primaryColor};
      font-weight: ${wMedium};
    }
  }
`;

type Props = {
  wrapperColor: PersonalityTypes[],
  image: string,
  persona: string,
  personId: number,
  companyId: number,
  title: string,
  actionAddBtn: () => void
  subscribed: boolean;
  views: number;
  downloads: number;
  executiveSubscribed: number
} | typeof defaultProps;

const defaultProps = {
  wrapperColor: [],
  image: '',
  persona: '',
  personId: 0,
  companyId: 0,
  title: '',
  actionAddBtn() { },
  subscribed: false,
  views: 0,
  downloads: 0,
  executiveSubscribed: 0,
};

const EngagementCompanyTableBody = function EngagementCompanyTableBody(props: Props) {
  const {
    persona, image, title, actionAddBtn, wrapperColor, companyId,
    subscribed, views, downloads, executiveSubscribed,
  } = props;
  return (
    <Body>
      <div className="body-item body-profile">
        <EngagementProfileWidget
          companyId={companyId}
          persona={persona}
          image={image}
          title={title}
          actionAddBtn={actionAddBtn}
          wrapperColor={wrapperColor}
          subscribed={subscribed}
          imageClassName="engagement-company"
          openInNewTab
        />
      </div>
      <div className="body-item body-accounts">{subscribed ? 'Added to Network' : 'Account not subscribed'}</div>
      <div className="body-item">{views}</div>
      <div className="body-item">{executiveSubscribed}</div>
      <div className="body-item">{downloads}</div>
    </Body>
  );
};

EngagementCompanyTableBody.defaultProps = defaultProps;
export default EngagementCompanyTableBody;
